import ThemeStore from './ThemeStore';
export default new ThemeStore();
